/**
 * This source code is quoted from rc-upload.
 * homepage: https://github.com/react-component/upload
 */
import omit from "omit.js"
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import {WebUI} from "../../wui-core/src/index"
import AjaxUpload from './AjaxUploader';

import { UploadProps } from './iUpload'

function empty() {
}

const defaultProps = {
    component: 'span',
    data: {},
    headers: {},
    name: 'file',
    multipart: false,
    onProgress: empty,
    onReady: empty,
    onStart: empty,
    onError: empty,
    onSuccess: empty,
    supportServerRender: false,
    multiple: false,
    beforeUpload: null,
    customRequest: null,
    withCredentials: false,
}

const Upload = forwardRef<any, UploadProps>((props, ref) => {
    const [Component, setComponent] = useState<any>(null);
    const innerRef = useRef<any>(null);

    useEffect(() => {
        if (props.supportServerRender) {
            setComponent(() => AjaxUpload);
            if (props.onReady) {
                props.onReady();
            }
        }
    }, [props.supportServerRender, props.onReady]);

    const abort = (file: any) => {
        if (innerRef.current) {
            innerRef.current.abort(file);
        }
    };

    useImperativeHandle(ref, () => ({
        abort
    }));

    if (props.supportServerRender) {
        if (Component) {
            return <Component {...omit(props, ["preventDefaultPreview", "enterDragger", "leaveDragger", "removeText", "downloadText", "fieldid"])}
                ref={innerRef}/>;
        }
        return null;
    }

    return <AjaxUpload {...omit(props, ["preventDefaultPreview", "enterDragger", "leaveDragger", "removeText", "downloadText", "fieldid"])}
        ref={innerRef}/>;
});

Upload.displayName = 'Upload';

export default WebUI({name: "upload", defaultProps})(Upload);
